var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLtiDeeplinkArtwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.777,
    height: 108.559,
    viewBox: "0 0 158.777 108.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52284",
    "data-name": "Group 52284",
    transform: "translate(-1023.223 -865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52254",
    "data-name": "Group 52254",
    transform: "translate(926 865)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142296",
    "data-name": "Path 142296",
    d: "M149.925,38l-3.982.365a52.157,52.157,0,0,0,1.412,8.187l3.875-.992A48.245,48.245,0,0,1,149.925,38Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142297",
    "data-name": "Path 142297",
    d: "M157.329,59.589l-3.371,2.154a52.99,52.99,0,0,0,5.012,6.625l2.99-2.656A48.947,48.947,0,0,1,157.329,59.589Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142298",
    "data-name": "Path 142298",
    d: "M161.85,71.362a52.787,52.787,0,0,0,6.417,5.269l2.287-3.281a48.846,48.846,0,0,1-5.931-4.871Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142299",
    "data-name": "Path 142299",
    d: "M171.765,78.872a52.542,52.542,0,0,0,7.473,3.615l1.451-3.726a48.716,48.716,0,0,1-6.9-3.34Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142300",
    "data-name": "Path 142300",
    d: "M149.722,33.532a48.912,48.912,0,0,1,.508-7.027l-3.959-.576a53.02,53.02,0,0,0-.549,7.6l0,.683,4-.053Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142301",
    "data-name": "Path 142301",
    d: "M158.772,5.349l-3.252-2.33a52.71,52.71,0,0,0-4.288,7.11l3.576,1.789A48.824,48.824,0,0,1,158.772,5.349Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142302",
    "data-name": "Path 142302",
    d: "M153.231,15.415l-3.709-1.5a52.4,52.4,0,0,0-2.49,7.928l3.9.89A48.069,48.069,0,0,1,153.231,15.415Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142303",
    "data-name": "Path 142303",
    d: "M163.224,0h-4.845l2.749,2.317C161.8,1.522,162.5.753,163.224,0Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142304",
    "data-name": "Path 142304",
    d: "M234.1,0h-.87c.137.143.28.281.415.426Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142305",
    "data-name": "Path 142305",
    d: "M152.328,49.234l-3.783,1.3a52.371,52.371,0,0,0,3.315,7.623l3.529-1.883A48.426,48.426,0,0,1,152.328,49.234Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142306",
    "data-name": "Path 142306",
    d: "M183.17,83.841a52.046,52.046,0,0,0,8.123,1.742l.524-3.965a48.12,48.12,0,0,1-7.5-1.609Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142307",
    "data-name": "Path 142307",
    d: "M248.747,19.2a52.213,52.213,0,0,0-2.9-7.789L242.221,13.1A48.443,48.443,0,0,1,244.9,20.3Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142308",
    "data-name": "Path 142308",
    d: "M239.286.838l-3.127,2.494a48.866,48.866,0,0,1,4.3,6.359l3.481-1.972A52.92,52.92,0,0,0,239.286.838Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142309",
    "data-name": "Path 142309",
    d: "M245.785,43.106l3.922.79a52.635,52.635,0,0,0,.985-8.248l-4-.158A48.555,48.555,0,0,1,245.785,43.106Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142310",
    "data-name": "Path 142310",
    d: "M245.8,24.028a48.562,48.562,0,0,1,.9,7.618l4-.152a52.486,52.486,0,0,0-.973-8.249Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142311",
    "data-name": "Path 142311",
    d: "M243.341,51.337a4.816,4.816,0,0,1,3.366,2.359,52.255,52.255,0,0,0,2.02-5.761l-3.846-1.1C244.448,48.356,243.926,49.859,243.341,51.337Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142312",
    "data-name": "Path 142312",
    d: "M207.113,81.225l.73,3.933a52.128,52.128,0,0,0,8.027-2.167l-1.347-3.765A48.168,48.168,0,0,1,207.113,81.225Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142313",
    "data-name": "Path 142313",
    d: "M231.081,69.183c-1.013.934-2.062,1.829-3.145,2.671l2.455,3.158c1.374-1.069,2.695-2.218,3.963-3.422a8.172,8.172,0,0,1-1.821-.829A3.98,3.98,0,0,1,231.081,69.183Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142314",
    "data-name": "Path 142314",
    d: "M195.641,81.972l-.211,3.994c.916.048,1.855.073,2.8.074a53.484,53.484,0,0,0,5.5-.286l-.416-3.979A49.857,49.857,0,0,1,195.641,81.972Z",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142315",
    "data-name": "Path 142315",
    d: "M218.085,77.788l1.643,3.647a52.644,52.644,0,0,0,7.281-4l-2.2-3.342A48.639,48.639,0,0,1,218.085,77.788Z",
    fill: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142316",
    "data-name": "Path 142316",
    d: "M201.958,60.392l-.616.071a27.739,27.739,0,0,1-3.114.179,27.315,27.315,0,0,1-4.533-.38l-.612-.1L189.2,65.514a33.276,33.276,0,0,1-4.1-1.454l.356-6.6-.54-.306a27.171,27.171,0,0,1-6.062-4.66l-.435-.444L172.137,54.1a33.508,33.508,0,0,1-2.469-3.588l4.166-5.127-.259-.566a26.944,26.944,0,0,1-2.168-7.334l-.089-.615-6.285-2.033c-.016-.432-.026-.866-.026-1.3,0-1.006.047-2.029.141-3.053l6.381-1.7.122-.609a26.92,26.92,0,0,1,2.555-7.209l.289-.551-3.89-5.341a33.343,33.343,0,0,1,2.656-3.453L179.426,14l.457-.42a27.172,27.172,0,0,1,6.3-4.335l.555-.276-.008-6.612a33.031,33.031,0,0,1,4.174-1.233L194.5,6.676l.617-.072a27.723,27.723,0,0,1,3.114-.178,27.359,27.359,0,0,1,4.533.379l.612.1,3.88-5.353a32.984,32.984,0,0,1,4.1,1.453L211,9.609l.54.306a27.178,27.178,0,0,1,6.064,4.659l.434.445,6.285-2.05a33.4,33.4,0,0,1,2.468,3.588l-4.166,5.126.259.565a26.894,26.894,0,0,1,2.168,7.335l.09.615,6.284,2.033q.025.648.026,1.3c0,1.006-.046,2.03-.14,3.054l-6.382,1.7-.122.611a26.875,26.875,0,0,1-2.556,7.208l-.289.55,3.892,5.341a33.707,33.707,0,0,1-2.656,3.452l-6.165-2.378-.457.42a27.149,27.149,0,0,1-6.3,4.335l-.556.277.008,6.61a32.95,32.95,0,0,1-4.174,1.234Zm-3.73-41.281a14.423,14.423,0,1,0,14.423,14.422A14.439,14.439,0,0,0,198.228,19.111Z",
    transform: "translate(926 865)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142317",
    "data-name": "Path 142317",
    d: "M239.728,80.611l-1.8-3.71-.5-.089a12.933,12.933,0,0,1-4.8-1.9l-.432-.281-3.822,1.5a16.858,16.858,0,0,1-1.732-1.888l1.783-3.735-.236-.445a12.931,12.931,0,0,1-1.451-4.793l-.051-.51-3.565-2.061a16.816,16.816,0,0,1,.4-2.6l4.044-.939.2-.459a13.055,13.055,0,0,1,2.758-4.026l.36-.357-.616-4.1a16.687,16.687,0,0,1,2.306-1.337l3.25,2.575.487-.133a13.163,13.163,0,0,1,4.86-.38l.5.053,2.835-3.05a16.614,16.614,0,0,1,2.455.947l.015,4.135.414.3a13.124,13.124,0,0,1,3.422,3.631l.268.424,4.148.315a16.583,16.583,0,0,1,.772,2.44l-3.214,2.58.027.513c.013.238.021.477.021.718a13.043,13.043,0,0,1-.75,4.375l-.17.478,2.326,3.417a16.749,16.749,0,0,1-1.4,2.073l-4.018-.9-.382.341a13.015,13.015,0,0,1-4.515,2.62l-.485.163-1.215,3.928a16.958,16.958,0,0,1-2.466.181ZM239.6,57.28a6.931,6.931,0,1,0,6.93,6.931A6.938,6.938,0,0,0,239.6,57.28Z",
    transform: "translate(926 865)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52280",
    "data-name": "Group 52280",
    transform: "translate(1023.223 853.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52277",
    "data-name": "Group 52277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52269",
    "data-name": "Group 52269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52268",
    "data-name": "Group 52268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28608",
    "data-name": "Rectangle 28608",
    d: "M0,0H50.612a7.407,7.407,0,0,1,7.407,7.407v4.183a7.575,7.575,0,0,1-7.575,7.575H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(2.692 85.932)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142324",
    "data-name": "Path 142324",
    d: "M103.984,93.817V96.7a8.8,8.8,0,0,1-1.064,4.224,7.763,7.763,0,0,1-6.782,4.173h-95A1.179,1.179,0,0,1,0,103.88v-.432a1.18,1.18,0,0,1,1.138-1.217H59.049a7.863,7.863,0,0,0,.813-1.307,8.236,8.236,0,0,0,.849-3.664V93.6a8.118,8.118,0,0,0-.235-1.951A7.867,7.867,0,0,0,59.134,88.8h-58A1.18,1.18,0,0,1,0,87.58v-.43a1.18,1.18,0,0,1,1.138-1.218H96.617a7.462,7.462,0,0,1,7.083,5.712A8.4,8.4,0,0,1,103.984,93.817Z",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142325",
    "data-name": "Path 142325",
    d: "M103.7,91.644H60.476A7.867,7.867,0,0,0,59.134,88.8h-58A1.18,1.18,0,0,1,0,87.58v-.43a1.18,1.18,0,0,1,1.138-1.218H96.617A7.462,7.462,0,0,1,103.7,91.644Z",
    fill: "#008fc4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142326",
    "data-name": "Path 142326",
    d: "M2.692,95.515l7.034.322-7.034.194Z",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142327",
    "data-name": "Path 142327",
    d: "M2.692,98.522l16.735.322-16.735.194Z",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52272",
    "data-name": "Group 52272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52271",
    "data-name": "Group 52271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52270",
    "data-name": "Group 52270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28609",
    "data-name": "Rectangle 28609",
    d: "M0,0H49.519a7.154,7.154,0,0,1,7.154,7.154V8.19a6.718,6.718,0,0,1-6.718,6.718H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(63.006 119.965) rotate(-180)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28610",
    "data-name": "Rectangle 28610",
    d: "M0,0H56.437a6.985,6.985,0,0,1,6.985,6.985V8.078a6.83,6.83,0,0,1-6.83,6.83H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(117.058 119.965) rotate(-180)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28611",
    "data-name": "Rectangle 28611",
    width: 71.131,
    height: 2.23,
    rx: 1.037,
    transform: "translate(120 119.965) rotate(180)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28612",
    "data-name": "Rectangle 28612",
    width: 71.131,
    height: 2.23,
    rx: 1.037,
    transform: "translate(120 107.287) rotate(180)",
    fill: "#484848"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142328",
    "data-name": "Path 142328",
    d: "M117.058,112.511l-7.689.251,7.689.151Z",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142329",
    "data-name": "Path 142329",
    d: "M117.058,109.08l-18.293.251,18.293.151Z",
    fill: "#cbcbcb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52276",
    "data-name": "Group 52276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52274",
    "data-name": "Group 52274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52273",
    "data-name": "Group 52273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28613",
    "data-name": "Rectangle 28613",
    d: "M0,0H53.452a8.16,8.16,0,0,1,8.16,8.16v5.4A8.345,8.345,0,0,1,53.267,21.9H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(9.629 64.069)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142330",
    "data-name": "Path 142330",
    d: "M71.271,72.568v4.714a5.556,5.556,0,0,1-2.515,4.694,4.661,4.661,0,0,1-2.48.72H8.007a1.3,1.3,0,0,0-1.236,1.36v.556a1.3,1.3,0,0,0,1.236,1.36H108.668a8.317,8.317,0,0,0,6.982-4,9.981,9.981,0,0,0,1.543-5.382V72.875a9.485,9.485,0,0,0-.795-3.829,7.98,7.98,0,0,0-7.21-4.976H8.007a1.3,1.3,0,0,0-1.236,1.359v.556a1.3,1.3,0,0,0,1.236,1.36H66.454A4.637,4.637,0,0,1,70,69.046,5.5,5.5,0,0,1,71.271,72.568Z",
    fill: "#ff8034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142331",
    "data-name": "Path 142331",
    d: "M6.771,84.056v.556a1.3,1.3,0,0,0,1.236,1.36H108.668a8.317,8.317,0,0,0,6.982-4H68.756a4.661,4.661,0,0,1-2.48.72H8.007A1.3,1.3,0,0,0,6.771,84.056Z",
    fill: "#df702e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142332",
    "data-name": "Path 142332",
    d: "M9.629,75.021l7.47.368-7.47.222Z",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142333",
    "data-name": "Path 142333",
    d: "M9.629,69.98l17.771.368L9.629,70.57Z",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52275",
    "data-name": "Group 52275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142334",
    "data-name": "Path 142334",
    d: "M61.982,70.275a3.94,3.94,0,0,0-1.561,1.836,2.229,2.229,0,0,0-.122.639c-.065,1.517,0,4.949,0,4.949l-3.462-1.716L53.383,77.7V73.047a3.3,3.3,0,0,1,.847-2.3,1.373,1.373,0,0,1,.956-.476Z",
    fill: "#ff8034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142335",
    "data-name": "Path 142335",
    d: "M61.982,70.275a3.94,3.94,0,0,0-1.561,1.836l-6.939.068a2.377,2.377,0,0,1,1.7-1.9Z",
    fill: "#df702e"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtiDeeplinkArtwork);
export default __webpack_public_path__ + "static/media/LTI-deeplink-artwork.4cc4e321f2612b7a142f41a760abc13c.svg";
export { ForwardRef as ReactComponent };